/* NUVEK — interacciones de la tienda (vanilla, sin librerías) */
(function () {
  'use strict';

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var io = null;

  /* Ejecuta fn después de que el navegador pinte (mejora el INP: la respuesta visual va primero) */
  function afterPaint(fn) {
    var done = false;
    function run() { if (done) return; done = true; fn(); }
    requestAnimationFrame(function () { setTimeout(run, 0); });
    setTimeout(run, 100); /* respaldo: nunca esperar más de 0,1 s */
  }
  /* Ejecuta fn cuando el navegador esté libre */
  function whenIdle(fn) {
    if ('requestIdleCallback' in window) requestIdleCallback(fn, { timeout: 1500 });
    else setTimeout(fn, 300);
  }

  function formatNumber(n, decimals) {
    try {
      return n.toLocaleString('es-CL', { minimumFractionDigits: decimals, maximumFractionDigits: decimals });
    } catch (e) {
      return n.toFixed(decimals);
    }
  }

  function countUp(el) {
    if (el.dataset.nvDone) return;
    el.dataset.nvDone = '1';
    var target = parseFloat(el.dataset.nvCount);
    if (isNaN(target)) return;
    var decimals = (el.dataset.nvCount.split('.')[1] || '').length;
    if (reduceMotion) { el.textContent = formatNumber(target, decimals); return; }
    var start = null;
    var dur = 1600;
    function step(ts) {
      if (!start) start = ts;
      var p = Math.min((ts - start) / dur, 1);
      var eased = 1 - Math.pow(1 - p, 3);
      el.textContent = formatNumber(target * eased, decimals);
      if (p < 1) requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
  }

  /* ---------- Reveal + contadores ---------- */
  function initReveal(root) {
    var els = (root || document).querySelectorAll('.nv-reveal:not(.nv-visible), [data-nv-count]');
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('nv-visible'); if (el.dataset.nvCount) countUp(el); });
      return;
    }
    if (!io) {
      io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          var el = entry.target;
          el.classList.add('nv-visible');
          if (el.dataset.nvCount) countUp(el);
          io.unobserve(el);
        });
      }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    }
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---------- Carrusel de reseñas ---------- */
  function initSliders(root) {
    (root || document).querySelectorAll('[data-nv-slider]').forEach(function (wrap) {
      if (wrap.dataset.nvInit) return;
      wrap.dataset.nvInit = '1';
      var track = wrap.querySelector('[data-nv-track]');
      if (!track) return;
      var prev = wrap.querySelector('[data-nv-prev]');
      var next = wrap.querySelector('[data-nv-next]');
      function amount() {
        var card = track.firstElementChild;
        return card ? card.getBoundingClientRect().width + 22 : track.clientWidth;
      }
      if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -amount(), behavior: 'smooth' }); });
      if (next) next.addEventListener('click', function () {
        if (track.scrollLeft + track.clientWidth >= track.scrollWidth - 4) {
          track.scrollTo({ left: 0, behavior: 'smooth' });
        } else {
          track.scrollBy({ left: amount(), behavior: 'smooth' });
        }
      });
      var auto = parseInt(wrap.dataset.nvAutoplay || '0', 10);
      if (auto > 0 && !reduceMotion) {
        var timer = null;
        var play = function () { timer = setInterval(function () { if (next) next.click(); }, auto * 1000); };
        var stop = function () { clearInterval(timer); };
        wrap.addEventListener('mouseenter', stop);
        wrap.addEventListener('mouseleave', play);
        wrap.addEventListener('touchstart', stop, { passive: true });
        play();
      }
    });
  }

  /* ---------- Página de producto ---------- */
  function nvDots(s) { return String(s).replace(/,/g, '.'); }
  function money(cents, format) { return nvDots(moneyRaw(cents, format)); }
  function moneyRaw(cents, format) {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      try { return window.Shopify.formatMoney(cents, format); } catch (e) {}
    }
    var value = (cents / 100);
    var decimals = format && format.indexOf('no_decimals') === -1 && format.indexOf('amount}}') !== -1 ? 2 : 0;
    var str = formatNumber(value, decimals);
    return format ? format.replace(/\{\{\s*[a-z_]+\s*\}\}/, str) : '$' + str;
  }

  function initProduct(root) {
    (root || document).querySelectorAll('[data-nv-pdp]').forEach(function (pdp) {
      if (pdp.dataset.nvInit) return;
      pdp.dataset.nvInit = '1';

      var moneyFormat = pdp.dataset.moneyFormat || '${{amount_no_decimals_with_comma_separator}}';
      var cartUrl = pdp.dataset.cartUrl || '/cart';
      var cartAddUrl = pdp.dataset.cartAddUrl || '/cart/add';

      /* Galería */
      var mainImg = pdp.querySelector('[data-nv-main-img]');
      var thumbs = Array.prototype.slice.call(pdp.querySelectorAll('[data-nv-thumb]'));
      var current = 0;
      function show(i) {
        if (!mainImg || !thumbs.length) return;
        current = (i + thumbs.length) % thumbs.length;
        var t = thumbs[current];
        mainImg.classList.add('is-fading');
        setTimeout(function () {
          mainImg.src = t.dataset.src;
          mainImg.srcset = t.dataset.srcset || '';
          mainImg.alt = t.dataset.alt || '';
          mainImg.classList.remove('is-fading');
        }, 180);
        thumbs.forEach(function (x, k) { x.classList.toggle('is-active', k === current); });
        dots.forEach(function (x, k) { x.classList.toggle('is-active', k === current); });
        if (t.scrollIntoView && t.parentElement && t.parentElement.scrollWidth > t.parentElement.clientWidth) {
          t.parentElement.scrollTo({ left: t.offsetLeft - t.parentElement.clientWidth / 2 + t.clientWidth / 2, behavior: 'smooth' });
        }
      }
      var dots = Array.prototype.slice.call(pdp.querySelectorAll('[data-nv-dot]'));
      dots.forEach(function (d, k) { d.addEventListener('click', function () { show(k); }); });
      thumbs.forEach(function (t, k) { t.addEventListener('click', function () { show(k); }); });
      pdp.querySelectorAll('[data-nv-gal-prev]').forEach(function (b) { b.addEventListener('click', function () { show(current - 1); }); });
      pdp.querySelectorAll('[data-nv-gal-next]').forEach(function (b) { b.addEventListener('click', function () { show(current + 1); }); });
      var main = pdp.querySelector('.nv-pdp__main');
      if (main && thumbs.length > 1) {
        var x0 = null;
        main.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
        main.addEventListener('touchend', function (e) {
          if (x0 === null) return;
          var dx = e.changedTouches[0].clientX - x0;
          if (Math.abs(dx) > 40) show(current + (dx < 0 ? 1 : -1));
          x0 = null;
        });
      }

      /* Cantidad */
      var qty = pdp.querySelector('[data-nv-qty]');
      pdp.querySelectorAll('[data-nv-qty-btn]').forEach(function (b) {
        b.addEventListener('click', function () {
          var v = parseInt(qty.value, 10) || 1;
          v += parseInt(b.dataset.nvQtyBtn, 10);
          qty.value = Math.max(1, Math.min(99, v));
        });
      });

      /* Variantes */
      var variantsEl = pdp.querySelector('[data-nv-variants]');
      var variants = variantsEl ? JSON.parse(variantsEl.textContent) : [];
      var idInput = pdp.querySelector('[data-nv-variant-id]');
      var priceNow = pdp.querySelectorAll('[data-nv-price-now]');
      var priceWas = pdp.querySelectorAll('[data-nv-price-was]');
      var saveEls = pdp.querySelectorAll('[data-nv-save]');
      var badgeEls = pdp.querySelectorAll('[data-nv-badge]');
      var addBtns = pdp.querySelectorAll('[data-nv-add]');
      var stockEl = pdp.querySelector('[data-nv-stock]');
      var optionInputs = pdp.querySelectorAll('[data-nv-option]');

      function selectedOptions() {
        var groups = {};
        optionInputs.forEach(function (inp) {
          if (inp.checked || inp.tagName === 'SELECT') groups[inp.dataset.nvOption] = inp.value;
        });
        return groups;
      }

      /* Pinta precio, precio anterior, ahorro y % en toda la página (ficha, galería, barra fija, oferta final) */
      function paintPrice(price, compare) {
        var onSale = compare && compare > price;
        var pct = onSale ? Math.floor((compare - price) * 100 / compare) : 0;
        priceNow.forEach(function (el) { el.textContent = money(price, moneyFormat); });
        priceWas.forEach(function (el) { el.textContent = onSale ? money(compare, moneyFormat) : ''; el.hidden = !onSale; });
        saveEls.forEach(function (el) {
          el.hidden = !onSale;
          var span = el.querySelector('[data-nv-save-amount]');
          if (span && onSale) span.textContent = money(compare - price, moneyFormat);
        });
        badgeEls.forEach(function (el) { el.hidden = !onSale; if (onSale) el.textContent = '-' + pct + '%'; });
        document.querySelectorAll('[data-nv-sync]').forEach(function (el) {
          var k = el.dataset.nvSync;
          if (k === 'now') el.textContent = money(price, moneyFormat);
          else if (k === 'was') el.textContent = onSale ? money(compare, moneyFormat) : '';
          else if (k === 'badge') { el.hidden = !onSale; if (onSale) el.textContent = '-' + pct + '%'; }
        });
      }

      /* ---- Modo "packs del formulario": los packs de la página usan los descuentos de Releasit ---- */
      function rsiOffersFor() {
        var list = window._RSI_COD_FORM_QUANTIY_OFFERS || window._RSI_COD_FORM_QUANTITY_OFFERS;
        var pid = String(pdp.dataset.productId || '');
        if (!list || !pid) return null;
        for (var i = 0; i < list.length; i++) {
          var o = list[i];
          if (o && o.isActive !== false && o.offers && o.offers.length && (o.pIds === 'all' || (o.pIds || []).map(String).indexOf(pid) > -1)) return o.offers.slice().sort(function (a, b) { return (a.pos || 0) - (b.pos || 0); });
        }
        return null;
      }
      function offerPrice(base, offer) {
        var qty = offer.qty || 1;
        var total = base * qty;
        var ds = offer.ds || {};
        if (ds.t === 'percentage') total = total * (1 - (ds.v || 0) / 10000);
        else if (ds.t === 'fixed_amount' || ds.t === 'fixed') total = total - (ds.v || 0);
        return Math.round(total / 100) * 100; /* pesos enteros, como el formulario */
      }
      var qtyOffers = null;
      function setupQtyMode() {
        if (qtyOffers || !variants.length) return;
        var cards = pdp.querySelectorAll('.nv-bundle__item');
        if (!cards.length) return;
        var offers = rsiOffersFor();
        if (!offers || offers.length < 2) return;
        qtyOffers = offers;
        pdp.dataset.nvQtyMode = '1';
        var base = variants[0].price, baseCompare = variants[0].compare_at_price || 0;
        cards.forEach(function (card, i) {
          var off = offers[i];
          if (!off) { card.hidden = true; return; }
          var qty = off.qty || 1;
          var price = offerPrice(base, off);
          var compare = baseCompare * qty;
          card.dataset.nvPrice = price;
          card.dataset.nvCompare = compare;
          var b = card.querySelector('.nv-bundle__prices b'); if (b) b.textContent = money(price, moneyFormat);
          var sEl = card.querySelector('.nv-bundle__prices s'); if (sEl) sEl.textContent = compare > price ? money(compare, moneyFormat) : '';
          var chip = card.querySelector('.nv-bundle__chip'); if (chip && compare > price) chip.textContent = Math.floor((compare - price) * 100 / compare) + '% OFF';
          var save = card.querySelector('.nv-bundle__save b'); if (save && compare > price) save.textContent = money(compare - price, moneyFormat);
          var unit = card.querySelector('.nv-bundle__unit'); if (unit) unit.textContent = money(Math.round(price / qty / 100) * 100, moneyFormat) + ' c/u';
        });
        /* Se pide siempre la opción "1 unidad": el pack lo aplica el formulario */
        if (idInput) idInput.value = variants[0].id;
        applyQtySelection();
        syncMini();
      }
      function applyQtySelection() {
        if (!qtyOffers) return;
        var cards = Array.prototype.slice.call(pdp.querySelectorAll('.nv-bundle__item'));
        var idx = cards.findIndex(function (c) { var i = c.querySelector('input'); return i && i.checked; });
        if (idx < 0) idx = 0;
        pdp._codOfferIndex = idx;
        var c = cards[idx];
        paintPrice(parseInt(c.dataset.nvPrice, 10), parseInt(c.dataset.nvCompare, 10));
        if (idInput) idInput.value = variants[0].id;
      }

      function updateVariant() {
        if (qtyOffers) { applyQtySelection(); return; }
        if (!variants.length || !optionInputs.length) return;
        var sel = selectedOptions();
        var v = variants.find(function (vr) {
          return vr.options.every(function (val, i) { return sel[i + 1] === undefined || sel[i + 1] === val; });
        });
        if (!v) return;
        if (idInput) idInput.value = v.id;
        pdp.querySelectorAll('[data-nv-option-value]').forEach(function (el) {
          el.textContent = sel[el.dataset.nvOptionValue] || '';
        });
        paintPrice(v.price, v.compare_at_price);
        if (false) priceNow.forEach(function (el) { el.textContent = money(v.price, moneyFormat); });
        /* Otras secciones de la página (oferta final) siguen el mismo pack: precio y % siempre coinciden */
        document.querySelectorAll('[data-nv-sync]').forEach(function (el) {
          var k = el.dataset.nvSync;
          if (k === 'now') el.textContent = money(v.price, moneyFormat);
          else if (k === 'was') el.textContent = v.compare_at_price > v.price ? money(v.compare_at_price, moneyFormat) : '';
          else if (k === 'badge') {
            el.hidden = !(v.compare_at_price > v.price);
            if (!el.hidden) el.textContent = '-' + Math.floor((v.compare_at_price - v.price) * 100 / v.compare_at_price) + '%';
          }
        });
        var onSale = v.compare_at_price && v.compare_at_price > v.price;
        priceWas.forEach(function (el) {
          el.textContent = onSale ? money(v.compare_at_price, moneyFormat) : '';
          el.hidden = !onSale;
        });
        saveEls.forEach(function (el) {
          if (onSale) {
            el.hidden = false;
            var span = el.querySelector('[data-nv-save-amount]');
            if (span) span.textContent = money(v.compare_at_price - v.price, moneyFormat);
          } else { el.hidden = true; }
        });
        badgeEls.forEach(function (el) {
          if (onSale) {
            el.hidden = false;
            el.textContent = '-' + Math.floor((v.compare_at_price - v.price) * 100 / v.compare_at_price) + '%';
          } else { el.hidden = true; }
        });
        addBtns.forEach(function (b) {
          b.disabled = !v.available;
          var label = b.querySelector('[data-nv-label]');
          if (label) label.textContent = v.available ? b.dataset.labelOn : b.dataset.labelOff;
        });
        if (stockEl) {
          stockEl.classList.toggle('is-out', !v.available);
          stockEl.textContent = v.available ? stockEl.dataset.on : stockEl.dataset.off;
        }
        if (v.featured_image && mainImg) {
          var idx = thumbs.findIndex(function (t) { return t.dataset.mediaId == (v.featured_media && v.featured_media.id); });
          if (idx > -1) show(idx);
        }
        try {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', v.id);
          window.history.replaceState({}, '', url.toString());
        } catch (e) {}
      }
      function markChecked() {
        pdp.querySelectorAll('.nv-bundle__item').forEach(function (item, i) {
          var inp = item.querySelector('input');
          var on = !!(inp && inp.checked);
          item.classList.toggle('is-checked', on);
          if (!on) return;
          /* La barra fija muestra el pack elegido (nombre y foto) */
          var lbl = document.querySelector('[data-nv-sticky-label]');
          if (lbl && item.dataset.nvPackLabel) lbl.textContent = item.dataset.nvPackLabel;
          var im = document.querySelector('[data-nv-sticky-img]');
          if (im && item.dataset.nvPackImg) { im.src = item.dataset.nvPackImg; im.removeAttribute('srcset'); }
          document.querySelectorAll('[data-nv-pick]').forEach(function (m) { m.classList.toggle('is-checked', parseInt(m.dataset.nvPick, 10) === i + 1); });
        });
      }
      /* Las tarjetas chicas de la oferta final copian precio y precio anterior de los packs de la ficha */
      function syncMini() {
        var cards = pdp.querySelectorAll('.nv-bundle__item');
        document.querySelectorAll('[data-nv-pick]').forEach(function (m) {
          var c = cards[parseInt(m.dataset.nvPick, 10) - 1];
          if (!c) { m.hidden = true; return; }
          var b = c.querySelector('.nv-bundle__prices b'), s = c.querySelector('.nv-bundle__prices s');
          var nb = m.querySelector('[data-nv-mini-now]'), ns = m.querySelector('[data-nv-mini-was]');
          if (nb && b) nb.textContent = b.textContent;
          if (ns && s) ns.textContent = s.textContent;
        });
      }
      pdp._nvSyncMini = syncMini;
      markChecked();
      syncMini();
      setupQtyMode();
      setTimeout(setupQtyMode, 1200);
      setTimeout(setupQtyMode, 3500);
      optionInputs.forEach(function (inp) {
        inp.addEventListener('change', function () { markChecked(); afterPaint(updateVariant); });
      });

      /* Envío del formulario: añadido (upsell) y "comprar ahora" */
      var form = pdp.querySelector('[data-nv-form]');
      var upsell = pdp.querySelector('[data-nv-upsell]');
      if (form) {
        form.addEventListener('submit', function (e) {
          var submitter = e.submitter;
          var buyNow = submitter && submitter.name === 'return_to';
          var withUpsell = upsell && upsell.checked && upsell.value;
          if (!withUpsell) return; /* envío normal de Shopify */
          e.preventDefault();
          var items = [{ id: parseInt(idInput.value, 10), quantity: parseInt(qty ? qty.value : 1, 10) || 1 }];
          items.push({ id: parseInt(upsell.value, 10), quantity: 1 });
          addBtns.forEach(function (b) { b.disabled = true; });
          fetch(cartAddUrl + '.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: items })
          })
            .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
            .then(function (res) {
              if (!res.ok) throw new Error(res.j && res.j.description);
              window.location.href = buyNow ? '/checkout' : cartUrl;
            })
            .catch(function (err) {
              addBtns.forEach(function (b) { b.disabled = false; });
              alert((err && err.message) || 'No pudimos agregar el producto. Inténtalo de nuevo.');
            });
        });
      }

      /* Barra fija de compra (móvil) */
      var sticky = pdp.querySelector('[data-nv-sticky]');
      var anchor = pdp.querySelector('[data-nv-buy-anchor]');
      if (sticky && anchor) {
        document.body.appendChild(sticky);
        var stickyTick = false;
        var checkSticky = function () {
          stickyTick = false;
          var past = anchor.getBoundingClientRect().bottom < 0;
          sticky.classList.toggle('is-on', past);
          document.body.classList.toggle('nv-has-sticky', past && window.innerWidth < 990);
        };
        window.addEventListener('scroll', function () {
          if (!stickyTick) { stickyTick = true; requestAnimationFrame(checkSticky); }
        }, { passive: true });
        window.addEventListener('resize', checkSticky);
        checkSticky();
        var stickyBtn = sticky.querySelector('[data-nv-sticky-btn]');
        if (stickyBtn && form) {
          stickyBtn.addEventListener('click', function () {
            /* Si el formulario contra entrega (Releasit u otra app) está activo, abrimos ese formulario */
            var cod = pdp.querySelector('._rsi-buy-now-button, [data-nv-cod-trigger]');
            if (cod) { openCod(cod, stickyBtn); return; }
            var btn = form.querySelector('[data-nv-add]');
            if (btn && form.requestSubmit) form.requestSubmit(btn);
            else if (btn) btn.click();
          });
        }
      }
    });
  }

  /* ---------- Titular palabra a palabra ---------- */
  function initSplit(root) {
    if (!document.documentElement.classList.contains('nv-anim') || reduceMotion) return;
    (root || document).querySelectorAll('[data-nv-split]:not(.nv-split-ready)').forEach(function (el) {
      var i = 0;
      function wrap(node) {
        Array.prototype.slice.call(node.childNodes).forEach(function (child) {
          if (child.nodeType === 3) {
            var parts = child.textContent.split(/(\s+)/);
            var frag = document.createDocumentFragment();
            parts.forEach(function (part) {
              if (!part) return;
              if (/^\s+$/.test(part)) { frag.appendChild(document.createTextNode(' ')); return; }
              var outer = document.createElement('span');
              outer.className = 'nv-w';
              var inner = document.createElement('span');
              inner.style.setProperty('--i', i++);
              inner.textContent = part;
              outer.appendChild(inner);
              frag.appendChild(outer);
            });
            node.replaceChild(frag, child);
          } else if (child.nodeType === 1) {
            wrap(child);
          }
        });
      }
      wrap(el);
      el.classList.add('nv-split-ready');
      requestAnimationFrame(function () {
        requestAnimationFrame(function () { el.classList.add('nv-split-on'); });
      });
    });
  }

  /* ---------- Parallax suave ---------- */
  var parallaxEls = [];
  var ticking = false;
  function updateParallax() {
    ticking = false;
    var vh = window.innerHeight;
    parallaxEls.forEach(function (el) {
      var amount = Math.min(parseFloat(el.dataset.nvParallax) || 0, 8);
      if (!amount) return;
      var r = el.parentElement.getBoundingClientRect();
      if (r.bottom < 0 || r.top > vh) return;
      var progress = (r.top + r.height / 2 - vh / 2) / (vh / 2 + r.height / 2);
      el.style.transform = 'translate3d(0,' + (progress * amount * -0.5).toFixed(2) + '%,0)';
    });
  }
  function initParallax(root) {
    if (reduceMotion) return;
    (root || document).querySelectorAll('[data-nv-parallax]').forEach(function (el) {
      if (parallaxEls.indexOf(el) === -1) parallaxEls.push(el);
    });
    if (parallaxEls.length && !initParallax.bound) {
      initParallax.bound = true;
      window.addEventListener('scroll', function () {
        if (!ticking) { ticking = true; requestAnimationFrame(updateParallax); }
      }, { passive: true });
    }
    updateParallax();
  }

  /* ---------- Inclinación 3D (solo ratón) ---------- */
  function initTilt(root) {
    if (reduceMotion || !window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
    (root || document).querySelectorAll('[data-nv-tilt]').forEach(function (el) {
      if (el.dataset.nvTiltInit) return;
      el.dataset.nvTiltInit = '1';
      var lastEvt = null, raf = 0;
      el.addEventListener('mousemove', function (e) {
        lastEvt = e;
        if (raf) return;
        raf = requestAnimationFrame(function () {
          raf = 0;
          var r = el.getBoundingClientRect();
          var x = (lastEvt.clientX - r.left) / r.width - 0.5;
          var y = (lastEvt.clientY - r.top) / r.height - 0.5;
          el.style.transition = 'transform .15s ease-out';
          el.style.transform = 'perspective(900px) rotateY(' + (x * 6).toFixed(2) + 'deg) rotateX(' + (y * -6).toFixed(2) + 'deg) translateY(-4px)';
        });
      }, { passive: true });
      el.addEventListener('mouseleave', function () {
        el.style.transition = 'transform .6s cubic-bezier(.22,1,.36,1)';
        el.style.transform = '';
      });
    });
  }

  /* ---------- Comparador antes / después ---------- */
  function initCompare(root) {
    (root || document).querySelectorAll('[data-nv-compare]').forEach(function (box) {
      if (box.dataset.nvInit) return;
      box.dataset.nvInit = '1';
      var range = box.querySelector('.nv-compare__range');
      if (!range) return;
      function set(v) { box.style.setProperty('--pos', v + '%'); }
      range.addEventListener('input', function () { set(range.value); box.dataset.nvTouched = '1'; });
      if (reduceMotion || !('IntersectionObserver' in window)) return;
      var hinted = false;
      new IntersectionObserver(function (entries, obs) {
        if (!entries[0].isIntersecting || hinted) return;
        hinted = true; obs.disconnect();
        var start = null;
        function anim(ts) {
          if (box.dataset.nvTouched) return;
          if (!start) start = ts;
          var t = (ts - start) / 1800;
          if (t > 1) { set(50); range.value = 50; return; }
          var v = 50 + Math.sin(t * Math.PI * 2) * 18;
          set(v.toFixed(1)); range.value = v;
          requestAnimationFrame(anim);
        }
        setTimeout(function () { requestAnimationFrame(anim); }, 700);
      }, { threshold: 0.5 }).observe(box);
    });
  }

  /* ---------- Videos: autoplay silencioso al verse ---------- */
  function initVideos(root) {
    var vids = (root || document).querySelectorAll('.nv-video__frame video');
    if (!vids.length) return;
    var vio = 'IntersectionObserver' in window ? new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        var v = e.target;
        if (e.isIntersecting) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
        else { v.pause(); }
      });
    }, { threshold: 0.5 }) : null;
    vids.forEach(function (v) {
      if (v.dataset.nvInit) return;
      v.dataset.nvInit = '1';
      v.muted = true; v.loop = true; v.playsInline = true; v.setAttribute('playsinline', '');
      if (vio && !reduceMotion) vio.observe(v);
      var btn = v.parentElement.querySelector('[data-nv-sound]');
      if (btn) btn.addEventListener('click', function () {
        v.muted = !v.muted;
        btn.classList.toggle('is-on', !v.muted);
        if (v.paused) v.play();
      });
    });
  }

  /* ---------- Barra de tiempo de la oferta (cuenta atrás real) ---------- */
  function parseDate(s) {
    if (!s) return NaN;
    s = String(s).trim().replace(' ', 'T');
    if (/^\d{4}-\d{2}-\d{2}$/.test(s)) s += 'T23:59:59';
    if (!/[zZ]|[+-]\d{2}:?\d{2}$/.test(s)) s += '-03:00'; /* hora de Chile por defecto */
    return Date.parse(s);
  }
  function pad(n) { return (n < 10 ? '0' : '') + n; }
  var urgencyEls = [];
  var urgencyTimer = null;
  /* Segundos transcurridos del día en hora de Chile (respeta horario de verano) */
  var chileFmt = null;
  function chileSecondsOfDay() {
    try {
      chileFmt = chileFmt || new Intl.DateTimeFormat('en-GB', { timeZone: 'America/Santiago', hour: '2-digit', minute: '2-digit', second: '2-digit', hourCycle: 'h23' });
      var parts = chileFmt.formatToParts(new Date());
      var get = function (t) { var p = parts.find(function (x) { return x.type === t; }); return p ? parseInt(p.value, 10) : 0; };
      return (get('hour') % 24) * 3600 + get('minute') * 60 + get('second');
    } catch (e) {
      var d = new Date(Date.now() - 3 * 3600000);
      return d.getUTCHours() * 3600 + d.getUTCMinutes() * 60 + d.getUTCSeconds();
    }
  }
  function tickUrgency() {
    if (document.hidden) return;
    var now = Date.now();
    var chileSec = null;
    urgencyEls.forEach(function (u) {
      var end = u._end, start = u._start;
      if (u.dataset.mode === 'daily') {
        var cutoff = (parseInt(u.dataset.cutoff, 10) || 0) * 3600;
        if (chileSec === null) chileSec = chileSecondsOfDay();
        var rem = (cutoff - chileSec + 86400) % 86400;
        if (rem === 0) rem = 86400;
        start = now - (86400 - rem) * 1000;
        end = now + rem * 1000;
      }
      var left = end - now;
      if (!(left > 0)) { u.hidden = true; return; }
      u.hidden = false;
      var s = Math.floor(left / 1000);
      var d = Math.floor(s / 86400); s -= d * 86400;
      var h = Math.floor(s / 3600); s -= h * 3600;
      var m = Math.floor(s / 60); s -= m * 60;
      var t = (d > 0 ? d + 'd ' : '') + pad(h) + ':' + pad(m) + ':' + pad(s);
      var timeEl = u.querySelector('[data-nv-time]');
      if (timeEl) timeEl.textContent = t;
      var total = isNaN(start) || start >= end ? 7 * 86400000 : end - start;
      var pct = Math.max(4, Math.min(100, (left / total) * 100));
      var fill = u.querySelector('[data-nv-fill]');
      if (fill) fill.style.width = pct.toFixed(3) + '%';
    });
  }
  function initUrgency(root) {
    (root || document).querySelectorAll('[data-nv-urgency]').forEach(function (u) {
      if (u.dataset.nvInit) return;
      u.dataset.nvInit = '1';
      u._end = parseDate(u.dataset.end);
      u._start = parseDate(u.dataset.start);
      if (u.dataset.mode !== 'daily' && isNaN(u._end)) return;
      urgencyEls.push(u);
    });
    if (urgencyEls.length) {
      tickUrgency();
      if (!urgencyTimer) urgencyTimer = setInterval(tickUrgency, 1000);
    }
  }

  /* ---------- Botón del formulario contra entrega con los colores de la marca ---------- */
  function brandCodButtons() {
    var css = getComputedStyle(document.documentElement);
    var accent = (css.getPropertyValue('--nv-accent') || '#FF6B1A').trim();
    var radius = (css.getPropertyValue('--nv-btn-radius') || '40px').trim();
    document.querySelectorAll('.nv-pdp ._rsi-buy-now-button').forEach(function (b) {
      if (b.dataset.nvBranded === accent) return;
      b.style.setProperty('background', accent, 'important');
      b.style.setProperty('border-color', accent, 'important');
      b.style.setProperty('border-radius', radius, 'important');
      b.style.setProperty('box-shadow', '0 10px 26px rgba(255,107,26,.35)', 'important');
      b.style.setProperty('font-size', '17px', 'important');
      b.dataset.nvBranded = accent;
    });
  }
  function resetBrand() {
    document.querySelectorAll('.nv-pdp ._rsi-buy-now-button[data-nv-branded]').forEach(function (b) {
      if (!/255,\s*107|ff6b1a/i.test(b.getAttribute('style') || '')) b.removeAttribute('data-nv-branded');
    });
  }
  /* Marca la zona de compra cuando el formulario COD está activo (sustituye a :has(), más caro) */
  function markCod() {
    document.querySelectorAll('.nv-pdp__buy').forEach(function (el) {
      el.classList.toggle('nv-has-cod', !!el.querySelector('._rsi-buy-now-button'));
    });
  }
  function initCodButtons() {
    brandCodButtons();
    markCod();
    if (!('MutationObserver' in window) || initCodButtons.bound) return;
    initCodButtons.bound = true;
    var pending = false;
    var mo = new MutationObserver(function () {
      if (pending) return;
      pending = true;
      afterPaint(function () { pending = false; brandCodButtons(); markCod(); });
    });
    /* Releasit pinta su botón con estilos propios al cargar: reaplicamos la marca un par de veces */
    setTimeout(function () { resetBrand(); brandCodButtons(); markCod(); }, 1200);
    setTimeout(function () { resetBrand(); brandCodButtons(); markCod(); }, 3500);
    document.querySelectorAll('.nv-pdp__buy').forEach(function (el) {
      mo.observe(el, { childList: true, subtree: true });
    });
  }

  /* Si no hay opiniones visibles en la página, las estrellas no enlazan a una sección vacía */
  function fixRatingLinks() {
    document.querySelectorAll('a.nv-pdp__rating[href^="#"]').forEach(function (a) {
      var target = document.querySelector(a.getAttribute('href'));
      if (!target) {
        a.removeAttribute('href');
        var span = a.querySelector(':scope > span:last-of-type');
        if (span && /Ver opiniones/i.test(span.textContent)) span.textContent = 'Calificación de nuestros clientes';
      }
    });
  }

  /* Abre el formulario COD después de pintar la respuesta visual del botón tocado */
  function selectCodOffer(idx) {
    if (!idx) return;
    var tries = 0, clicks = 0;
    (function look() {
      var modal = document.getElementById('_rsi-cod-form-modal');
      var open = modal && getComputedStyle(modal).display !== 'none';
      var opts = open ? modal.querySelectorAll('._rsi-quantity-offers-offer-container') : [];
      if (opts.length > idx) {
        var target = opts[idx];
        if (target.classList.contains('_rsi-quantity-offers-selected')) return; /* ya está marcado */
        if (clicks < 4) {
          clicks++;
          (target.querySelector('._rsi-quantity-offers-offer') || target).click();
        }
      }
      if (++tries < 40) setTimeout(look, 150);
    })();
  }
  function openCod(cod, pressed) {
    if (pressed) pressed.classList.add('is-pressed');
    var pdpEl = cod.closest && cod.closest('[data-nv-pdp]');
    var offerIdx = pdpEl && pdpEl.dataset.nvQtyMode ? (pdpEl._codOfferIndex || 0) : 0;
    afterPaint(function () {
      cod.dataset.nvPass = '1';
      cod.click();
      delete cod.dataset.nvPass;
      selectCodOffer(offerIdx);
      if (pressed) setTimeout(function () { pressed.classList.remove('is-pressed'); }, 250);
    });
  }
  /* Botones de compra fuera de la ficha: abren directamente el formulario contra entrega */
  function initOpenCod() {
    if (initOpenCod.bound) return;
    initOpenCod.bound = true;
    document.addEventListener('click', function (e) {
      if (!e.target.closest) return;
      /* Toque directo en el botón de Releasit: primero respuesta visual, luego el formulario */
      var rsi = e.target.closest('.nv-pdp ._rsi-buy-now-button');
      if (rsi) {
        if (rsi.dataset.nvPass) return; /* es nuestro clic diferido: dejamos pasar */
        e.preventDefault();
        e.stopImmediatePropagation();
        openCod(rsi, rsi);
        return;
      }
      var link = e.target.closest('[data-nv-open-cod], [data-nv-pick]');
      if (!link) return;
      /* Tarjeta chica de la oferta final: primero marca ese pack en la ficha */
      if (link.dataset.nvPick) {
        var main = document.querySelector('[data-nv-pdp]');
        var card = main && main.querySelectorAll('.nv-bundle__item')[parseInt(link.dataset.nvPick, 10) - 1];
        var radio = card && card.querySelector('input');
        if (radio && !radio.checked) { radio.checked = true; radio.dispatchEvent(new Event('change', { bubbles: true })); }
        if (!link.hasAttribute('data-nv-open-cod')) { e.preventDefault(); return; }
      }
      var cod = document.querySelector('.nv-pdp ._rsi-buy-now-button, .nv-pdp [data-nv-cod-trigger]');
      if (!cod) {
        /* Sin formulario contra entrega: el botón grande agrega al carrito; los enlaces siguen su camino */
        var f = link.tagName === 'BUTTON' && link.closest('form');
        if (f) {
          e.preventDefault();
          var add = f.querySelector('[data-nv-add]');
          if (f.requestSubmit) f.requestSubmit(add || undefined); else if (add) add.click();
        }
        return;
      }
      e.preventDefault();
      openCod(cod, link);
    }, true);
  }

  var pauseIO = null;
  function initPauseOffscreen(root) {
    if (!('IntersectionObserver' in window)) return;
    pauseIO = pauseIO || new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { e.target.classList.toggle('nv-offscreen', !e.isIntersecting); });
    }, { rootMargin: '100px 0px' });
    (root || document).querySelectorAll('.nv-marquee, .nv-rmarquee, .nv-hero__visual, .nv-spot__media, .nv-guarantee__seal, .nv-benefits__media, .nv-brand__media, .nv-brand__since, .nv-cta__media, .nv-urgency, .nv-bundle, .nv-pdp__buy, .nv-banner').forEach(function (el) {
      if (el.dataset.nvPause) return;
      el.dataset.nvPause = '1';
      pauseIO.observe(el);
    });
  }

  function initAll(root) {
    window.nvReady = true;
    /* Crítico: compra, contador y aparición de contenido */
    initOpenCod();
    initCodButtons();
    initProduct(root);
    initUrgency(root);
    initSplit(root);
    initReveal(root);
    /* Secundario: cuando el navegador esté libre */
    whenIdle(function () {
      fixRatingLinks();
      initPauseOffscreen(root);
      initParallax(root);
      initSliders(root);
      initCompare(root);
      initVideos(root);
      initTilt(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
